import React from 'react';
import { AutocompleteBase } from 'components';

const AutocompleteUsers = ({ setter, settings = null, selected = null }) => {
  settings = settings ?? {};
  settings['@resourceType'] = 'user';
  settings.displayLabel = false;
  settings.fullObjects = settings ? settings.fullObjects ?? true : true;
  settings.multiple = settings ? settings.multiple ?? false : false;

  return (
    <AutocompleteBase setter={setter} settings={settings} selected={selected} />
  );
};

export default AutocompleteUsers;
